<template>
	<div id="streets" v-show="similarStreets.length > 1">
		
		<section v-show="similarStreets.length > 1"
			class="otherNeighborhoodsSection sectionPadBottom"
			style="max-height: 100px"
		>
		<h2 class="mainTitle">
			עסקאות נוספות ב{{ summaryTypeName }}
			{{ $store.state.neighborhoodName }} לפי רחובות
		</h2>
			<div class="container-fluid otherNeighborhoods"  v-show="similarStreets.length > 1">
				<div
					class="similarCarousleWrap"
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-left: 50px;
						margin-right: 50px;
						margin-bottom: 120px;
						max-height: 100px;
					"
				>
					<div class="scroll-container">
						<a href="#" class="nav-arrow left" @click.prevent="scrollNavBar(-200)"></a>
						<div class="buttons-container2">
							<button v-for="(street, index) in similarStreets" :key="index"
							@click="filterStreet(street.id)" class="nav-button2">{{ street.title  }}</button>
						</div>
						<a href="#" class="nav-arrow right"  @click.prevent="scrollNavBar(200)"></a>
					</div>
				</div>
			</div>
			
		</section>
	</div>
</template>

<script>
export default {
	name: "StreetsScroller",
	props: {
		msg: String,
	},
	data() {
		return {
			current: 0,
			centerIndex: -1,
			scrollPosition: 0,
			contentWidth: 0,
			additional_total: 0,
		};
	},
	computed: {
		summaryTypeName() {
			if (("summaryTypeName", this.$store.state.neighborhoodId > 0)) {
				return "שכונה";
			}
			return "ישוב";
		},
		routeName() {
			return this.$route.query.view;
		},
		similarStreets() {
			var similar = this.$store.state.similarStreets;
			// if (similar == null){
			// 	similar = this.$store.state.otherSettlmentStreets;
			// }

			if (similar == null) {
				if (this.summaryTypeName == "ישוב") {
					// get all streets from this.$store.state.deals;
					// create object:
					// collect all streets from deals (distinct)...
					var streets = [];
					var ids = [];
					// check if route name is not 'street'
					if (this.routeName != "street" && this.routeName != "address") {
						//this.$store.state.deals.forEach((deal) => {
						this.$parent.initialDeals.forEach((deal) => {
							var str_obj = {};
							str_obj.id = deal.streetCode;
							if (
								ids.includes(str_obj.id) ||
								str_obj.id == null ||
								str_obj.id == 0
							) {
								return;
							}
							ids.push(str_obj.id);
							var str_name = deal.address;
							// remove all numbers from str_name if all of them in the end of string..
							var str_name_arr = str_name.split(" ");
							var last_word = str_name_arr[str_name_arr.length - 1];
							if (last_word.match(/^\d+$/)) {
								// remove last word
								str_name_arr.pop();
								str_name = str_name_arr.join(" ");
							}
							str_obj.title = str_name;
							streets.push(str_obj);
						});
					} else {
						this.$parent.initialDeals.forEach((deal) => {
							var str_obj = {};
							str_obj.id = deal.streetCode;
							if (
								ids.includes(str_obj.id) ||
								str_obj.id == null ||
								str_obj.id == 0
							) {
								return;
							}
							ids.push(str_obj.id);
							var str_name = deal.address;
							// remove all numbers from str_name if all of them in the end of string..
							var str_name_arr = str_name.split(" ");
							var last_word = str_name_arr[str_name_arr.length - 1];
							if (last_word.match(/^\d+$/)) {
								// remove last word
								str_name_arr.pop();
								str_name = str_name_arr.join(" ");
							}
							str_obj.title = str_name;
							streets.push(str_obj);
						});
					}

					similar = streets;


				}
			}

			//add 'כל הרחובות' to the beginning of the list
			similar.unshift({
				id: 0,
				title: "כל הרחובות",
			});

			// set unique by id
			similar = similar.filter(
				(street, index, self) =>
					index ===
					self.findIndex((t) => t.id === street.id)
			);

			return similar;
		},
	},
	methods: {
		filterStreet(streetId) {
			// get this component parent deals...
			this.$parent.selectStreet(streetId);
			this.current = streetId;
		},
		scrollNavBar(amount) {
			const container = document.querySelector('.buttons-container2');
            container.scrollLeft += amount;
        },
	},
	mounted() {
		
		
		const the_container = document.querySelector('.buttons-container2');
        let isDown = false;
        let startX;
        let scrollLeft;

        the_container.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - the_container.offsetLeft;
            scrollLeft = the_container.scrollLeft;
        });

        the_container.addEventListener('mouseleave', () => {
            isDown = false;
        });

        the_container.addEventListener('mouseup', () => {
            isDown = false;
        });

        the_container.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - the_container.offsetLeft;
            const walk = (x - startX) * 3;
            the_container.scrollLeft = scrollLeft - walk;
        });

        the_container.addEventListener('wheel', (e) => {
            e.preventDefault();
            the_container.scrollLeft += e.deltaY * 3;
        });
	},
	watch: {},
};
</script>


<style scoped>


body {
	font-family: Arial, sans-serif;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	margin: 0;
	background-color: #f0f0f0;
}
.scroll-container {
	margin-bottom: 20px;
	position: relative;
	max-width: 900px;
	width: 100%;
	overflow: hidden;
	background-color: white;
	border-radius: 20px;
	padding: 5px 40px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.1);
	z-index: 1;
}
.buttons-container2 {
	margin-left: 15px;
	margin-right: 15px;
	display: flex;
	overflow-x: auto;
	scroll-behavior: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
	scroll-snap-type: x proximity;
	padding: 10px;
}
.buttons-container2::-webkit-scrollbar {
	display: none;
}
.nav-button2 {
	font-weight: bold;
	background-color: white;
	border: 1px solid #e0e0e0;
	border-radius: 20px;
	padding: 10px 20px;
	margin: 0 5px;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	white-space: nowrap;
	flex-shrink: 0;
	scroll-snap-align: start;
}
.scroll-container::before,
.scroll-container::after {
	content: '';
	position: absolute;
	top: 0;
	bottom: 0;
	width: 40px;
	background: linear-gradient(to right, white, transparent);
	z-index: 1;
	pointer-events: none;
}
.scroll-container::before {
	left: 0;
	background: linear-gradient(to left, transparent, white);
}
.scroll-container::after {
	right: 0;
	background: linear-gradient(to right, transparent, white);
}
.nav-arrow {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.8);
	border: none;
	font-size: 20px;
	color: #333;
	cursor: pointer;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	border-radius: 50%;
}
.nav-arrow:hover {
	background-color: rgba(240, 240, 240, 0.9);
}
.nav-arrow.left {
	left: 5px;
}
.nav-arrow.right {
	right: 5px;
}
.nav-arrow.left::before {
	content: "\003E";
}
.nav-arrow.right::before {
	content: "\003C";
}


/* Media query for mobile screens */
@media (max-width: 768px) {
	/* Remove padding */
	.scroll-container {
		padding: 0;
	}
	
	/* Hide .nav-arrow.left and .nav-arrow.right */
	.nav-arrow.left,
	.nav-arrow.right {
		display: none;
	}
	#streets {
		margin-bottom: -50px;
	}
}

/* Media query for desktop screens */
@media (min-width: 769px) {
	#streets {
		margin-bottom: 50px;
	}
}
</style>
